module.exports = __webpack_public_path__ + "img/encyclopedia-britannica.e812338e.png";